import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { SWRConfig } from 'swr';
import { configureAxios, configureServices } from 'config';
import {
  AxiosInterceptor,
  DelayedLoadingToast,
  FileSystemRoutes,
  JsResizeHelper,
  KeepAlive,
  Modal,
  XsrfToken,
} from 'shared/components';
import { SignalRProvider } from 'shared/signalr/SignalrProvider';
import { authSelectors } from 'shared/state';

configureAxios();
configureServices();

function SWRUserScope({ children }: { children: React.ReactNode }) {
  const userId = useSelector(authSelectors.getUser)?.id ?? 'unauthenticated';
  return (
    <SWRConfig key={userId} value={{ provider: () => new Map() }}>
      {children}
    </SWRConfig>
  );
}

function App() {
  return (
    <IntlProvider locale="en">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <SWRUserScope>
          <SignalRProvider>
            <JsResizeHelper />
            <Modal.Provider>
              <FileSystemRoutes />
              <KeepAlive />
            </Modal.Provider>
            <XsrfToken />
            <AxiosInterceptor component={DelayedLoadingToast} />
            <ToastContainer position={toast.POSITION.BOTTOM_CENTER} />
          </SignalRProvider>
        </SWRUserScope>
      </BrowserRouter>
    </IntlProvider>
  );
}

export default App;
